export default {
  delay: 0,
  animation: 250,
  ghostClass: 'dragging-element__ghost',
  easing: 'cubic-bezier(0.2, 0, 0, 1)',
  chosenClass: 'dragging-element',
  dataIdAttr: 'data-id',
  forceFallback: true,
  filter: '.edit-box', // Selectors that do not lead to dragging (String or Function)
  preventOnFilter: false, // Call `event.preventDefault()` when triggered `filter`
}
